import { Injectable, inject } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';
import { StorageImage } from './storage-images.util';

/**
 * Single point of access for the shared "user-images" storage folder that
 * every image picker across the add/edit forms reads from. Handles listing
 * the previously uploaded images and permanently deleting them.
 */
@Injectable({ providedIn: 'root' })
export class StorageImageService {
  private storage = inject(AngularFireStorage);

  listSavedImages(folder = 'user-images'): Promise<StorageImage[]> {
    const listRef = firebase.storage().ref().child(folder);
    return listRef.listAll().then(res =>
      res.items.map(itemRef => ({
        path: itemRef.fullPath,
        imageDownloadPath: this.storage.ref(itemRef.fullPath).getDownloadURL()
      }))
    );
  }

  /**
   * Permanently removes an image from storage. Used to clear out the
   * duplicate uploads that build up in the shared folder.
   */
  deleteImage(path: string): Promise<void> {
    return firebase.storage().ref().child(path).delete();
  }
}
